export default server => {
    server.get('/v1/labels', schema => {
        const { models } = schema.labels.all();

        return models;
    });

    server.post('/labels', (schema, { requestBody }) => {
        const { name } = JSON.parse(requestBody);

        const { attrs } = schema.labels.create({
            name,
            category: 'Label'
        });

        return attrs;
    });
};
